module.exports = __webpack_public_path__ + "img/assent-man.64573937.svg";